{
  "login": "Логин",
  "domain": "Домен",
  "password": "Пароль",
  "loginBtn": "Войти",
  "without-ldap": "Без LDAP",
  "or-sign-in-with": "Или войдите с помощью",
  "oidc": {
    "connectionError": "Ошибка подключения к OIDC провайдеру",
    "unknownError": "Неизвестная ошибка"
  },
  "oidcCallback": {
    "title": "Ошибка авторизации",
    "provider": "Провайдер",
    "closeWindow": "Закрыть окно",
    "backToLogin": "Вернуться к входу",
    "errors": {
      "accessDenied": "Доступ запрещён",
      "invalidRequest": "Неверный запрос",
      "unauthorizedClient": "Неавторизованный клиент",
      "unsupportedResponseType": "Неподдерживаемый тип ответа",
      "invalidScope": "Неверная область доступа",
      "serverError": "Ошибка сервера",
      "temporarilyUnavailable": "Сервис временно недоступен",
      "unknown": "Неизвестная ошибка"
    }
  },
  "merge": {
    "title": "Пользователь уже существует",
    "description": "Пользователь с логином \"{{login}}\" уже есть в системе. Для объединения учётных записей подтвердите пароль от существующего аккаунта.",
    "confirmButton": "Подтвердить и войти",
    "orConfirmWith": "Или подтвердите через",
    "backToLogin": "Перейти на страницу входа",
    "sessionExpired": {
      "title": "Сессия истекла",
      "description": "Данные для объединения учётных записей не найдены или срок действия сессии истёк. Пожалуйста, выполните вход ещё раз."
    },
    "noMethods": {
      "title": "Нет доступных способов подтверждения",
      "description": "Для этой учётной записи не настроено ни одного доступного способа подтверждения. Обратитесь к администратору системы."
    },
    "error": {
      "title": "Ошибка подтверждения",
      "invalidCredentials": "Неверный логин или пароль",
      "unknown": "Произошла ошибка. Попробуйте позже."
    }
  },
  "retryLdap": "Повторить загрузку LDAP",
  "retryOidc": "Повторить загрузку OIDC",
  "loadingMethods": "Загрузка способов входа"
}
